import type { ThemeName } from './theme.enum';

/**
 * The authenticated user, as consumed by the UI. Built from an
 * MSAL `AccountInfo` + `idTokenClaims` — see
 * `@shared/auth/user-from-account.helper.ts`.
 */
export interface User {
  /** MSAL `homeAccountId`; unique per Entra home tenant. */
  readonly id: string;
  /** `preferred_username` / `username` (usually the UPN). */
  readonly username: string;
  /** `name` claim, falls back to `username`. */
  readonly displayName: string;
  /** Entra app-role assignments (`idTokenClaims.roles`). */
  readonly roles: readonly UserRole[];
  /** Home tenant id. */
  readonly tenantId: string;
  /** Optional language preference mirror (read from claims if present). */
  readonly language?: 'en-GB' | 'nl-NL';
  /** Optional theme preference mirror (read from claims if present). */
  readonly theme?: ThemeName;
}

export type UserRole = 'labtech' | 'dentist' | 'employee' | 'platform-admin';

export const ALL_USER_ROLES: readonly UserRole[] = ['labtech', 'dentist', 'employee', 'platform-admin'] as const;

export function isUserRole(value: string): value is UserRole {
  return (ALL_USER_ROLES as readonly string[]).includes(value);
}
